const actionTypes = require('constants/actionTypes');

const showModalCancel = () => {
    return {
        type: actionTypes.SHOW_MODAL_CANCEL,
    };
};

const hideModalCancel = () => {
    return {
        type: actionTypes.HIDE_MODAL_CANCEL,
    };
};

export default {
    showModalCancel,
    hideModalCancel,
};
